export default __webpack_public_path__ + "static/media/dress6.b38c8160.jpeg";